import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './Navigation.module.css';

const Navigation: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className={styles.navbar}>
      <div className={styles.container}>
        <Link to="/" className={styles.logoLink} onClick={closeMenu}>
          <img
            src="/assets/images/logo.png"
            alt="Brands2Buyers Logo"
            className={styles.logo}
          />
        </Link>
        <div className={styles.navMenu}>
          <Link to="/" className={styles.navLink}>
            Accueil
          </Link>
          <Link to="/evenement" className={styles.navLink}>
            Évènements
          </Link>
          <Link to="/inscriptions" className={styles.inscribeBtn}>
            S'INSCRIRE
          </Link>
          <Link to="/members" className={styles.memberBtn}>
            Member Access
          </Link>
        </div>
        <button
          className={styles.hamburger}
          aria-label="Menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>
      {menuOpen && (
        <div className={styles.mobileMenu}>
          <Link to="/" className={styles.mobileNavLink} onClick={closeMenu}>
            Accueil
          </Link>
          <Link to="/evenement" className={styles.mobileNavLink} onClick={closeMenu}>
            Évènements
          </Link>
          <Link to="/inscriptions" className={styles.mobileInscribeBtn} onClick={closeMenu}>
            S'INSCRIRE
          </Link>
          <Link to="/members" className={styles.mobileMemberBtn} onClick={closeMenu}>
            Member Access
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
